import { useState, createContext, useEffect, useRef } from "react";

export const MapToolboxContext = createContext();

export default function MapToolboxProvider({ children }) {
  const [activeId, setActiveId] = useState("");
  const [showHighwayStyle, setShowHighwayStyle] = useState(false);
  const activeIdRef = useRef(activeId);

  useEffect(() => {
    activeIdRef.current = activeId;
  }, [activeId]);

  return (
    <MapToolboxContext.Provider
      value={{
        activeId,
        setActiveId,
        activeIdRef,
        showHighwayStyle,
        setShowHighwayStyle,
      }}
    >
      {children}
    </MapToolboxContext.Provider>
  );
}
